import React from "react"
import Locations from "components/Common/Locations"
import MapComp from "components/Common/MapComp"
import {
  Avatar,
  Card,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Switch,
  Tag,
  Typography,
} from "antd"
import {
  AimOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  HomeOutlined,
  IdcardOutlined,
  NumberOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons"

const { Text } = Typography

export default function ProjectDetailsDesktop({
  formInput,
  handleInput,
  handleSelectChange,
  setIsErrorValid,
  matches_sm,
  userInfo,
  dataAddress,
  setDataAddress,
}) {
  return (
    <Space direction="vertical" style={{ width: "100%", paddingTop: 4 }} size={20}>
      {/* Overview header */}
      <div style={{
        borderRadius: 16,
        background: "linear-gradient(135deg, #1677ff, #0958d9)",
        padding: "20px 24px",
        color: "#fff",
        position: "relative",
        overflow: "hidden",
      }}>
        <div style={{
          position: "absolute", top: -20, left: -20,
          width: 100, height: 100, borderRadius: "50%",
          background: "rgba(255,255,255,0.08)",
        }} />
        <div style={{
          position: "absolute", bottom: -30, right: -10,
          width: 80, height: 80, borderRadius: "50%",
          background: "rgba(255,255,255,0.06)",
        }} />
        <Row align="middle" gutter={16}>
          <Col flex="auto">
            <Space align="start" size={14}>
              <Avatar
                size={48}
                icon={<FileTextOutlined />}
                style={{
                  background: "rgba(255,255,255,0.2)",
                  backdropFilter: "blur(10px)",
                  border: "2px solid rgba(255,255,255,0.3)",
                }}
              />
              <Space direction="vertical" size={2}>
                <Text strong style={{ fontSize: 17, color: "#fff" }}>
                  تکمیل اطلاعات پرونده
                </Text>
                <Text style={{ color: "rgba(255,255,255,0.75)", fontSize: 13 }}>
                  اطلاعات مالک، ساختمان و موقعیت پروژه را با دقت ثبت کنید
                </Text>
              </Space>
            </Space>
          </Col>
          <Col>
            <Space size={8}>
              {[
                { label: "مالکیت", value: formInput.ownershipTypeEnum === "2" ? "حقوقی" : "حقیقی" },
                { label: "واحد", value: formInput.unitNumber || "1" },
                { label: "لوله‌کشی", value: +formInput.pipingTypeEnum === 1 ? "توکار" : "روکار" },
              ].map(item => (
                <div key={item.label} style={{
                  background: "rgba(255,255,255,0.15)",
                  borderRadius: 10,
                  padding: "6px 14px",
                  textAlign: "center",
                  backdropFilter: "blur(10px)",
                }}>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)" }}>{item.label}</div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>{item.value}</div>
                </div>
              ))}
            </Space>
          </Col>
        </Row>
      </div>

      <Row gutter={[20, 20]}>
        {/* Owner card */}
        <Col xs={24} xl={10}>
          <Card
            size="small"
            bordered={false}
            style={{
              height: "100%",
              borderRadius: 16,
              background: "#fff",
              border: "1px solid rgba(22,119,255,0.10)",
              boxShadow: "0 2px 12px rgba(22,119,255,0.06)",
            }}
          >
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 18,
              paddingBottom: 14,
              borderBottom: "1px solid #f0f5ff",
            }}>
              <div style={{
                width: 36, height: 36, borderRadius: 10,
                background: "linear-gradient(135deg, #1677ff, #4096ff)",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <UserOutlined style={{ fontSize: 18, color: "#fff" }} />
              </div>
              <div>
                <Text strong style={{ fontSize: 14, display: "block" }}>مشخصات مالک</Text>
                <Text type="secondary" style={{ fontSize: 11 }}>اطلاعات هویتی و تماس</Text>
              </div>
            </div>
            <Row gutter={[12, 14]}>
              <Col xs={24}>
                <Form.Item label={<Text style={{ fontSize: 12, fontWeight: 500 }}>نام و نام خانوادگی</Text>} style={{ margin: 0 }}>
                  <Input
                    prefix={<UserOutlined style={{ color: "#bbb" }} />}
                    required
                    name="landlordName"
                    value={formInput.landlordName}
                    onChange={handleInput}
                    placeholder="نام کامل مالک"
                    style={{ borderRadius: 10, height: 42 }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item
                  label={<Text style={{ fontSize: 12, fontWeight: 500 }}>کدملی / شناسه ملی</Text>}
                  style={{ margin: 0 }}
                  validateStatus={formInput.landlordNaCode && formInput.landlordNaCode.length !== 10 ? "error" : ""}
                  help={
                    formInput.landlordNaCode && formInput.landlordNaCode.length !== 10
                      ? <Text type="danger" style={{ fontSize: 11 }}>باید دقیقاً ۱۰ رقم باشد</Text>
                      : <Text type="secondary" style={{ fontSize: 11 }}>۱۰ رقم</Text>
                  }
                >
                  <Input
                    prefix={<IdcardOutlined style={{ color: "#bbb" }} />}
                    required
                    name="landlordNaCode"
                    value={formInput.landlordNaCode}
                    type="number"
                    placeholder="0000000000"
                    onChange={e => {
                      handleInput(e)
                      setIsErrorValid(e.target.value.length !== 10)
                    }}
                    style={{ borderRadius: 10, height: 42 }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item
                  label={<Text style={{ fontSize: 12, fontWeight: 500 }}>شماره تماس</Text>}
                  style={{ margin: 0 }}
                  validateStatus={formInput.landlordPhoneNumber && formInput.landlordPhoneNumber.length !== 11 ? "error" : ""}
                  help={
                    formInput.landlordPhoneNumber && formInput.landlordPhoneNumber.length !== 11
                      ? <Text type="danger" style={{ fontSize: 11 }}>باید ۱۱ رقم باشد</Text>
                      : <Text type="secondary" style={{ fontSize: 11 }}>مثال: 09123456789</Text>
                  }
                >
                  <Input
                    prefix={<PhoneOutlined style={{ color: "#bbb" }} />}
                    required
                    name="landlordPhoneNumber"
                    value={formInput.landlordPhoneNumber}
                    dir="ltr"
                    placeholder="09xxxxxxxxx"
                    onChange={e => {
                      handleInput(e)
                      setIsErrorValid(e.target.value.length !== 11)
                    }}
                    style={{ borderRadius: 10, height: 42 }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item label={<Text style={{ fontSize: 12, fontWeight: 500 }}>شماره پرونده قبلی (تمدید بازرسی)</Text>} style={{ margin: 0 }}>
                  <Input
                    name="des1"
                    value={formInput.des1}
                    onChange={handleInput}
                    placeholder="در صورت نداشتن خالی بگذارید"
                    style={{ borderRadius: 10, height: 42 }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Building card */}
        <Col xs={24} xl={14}>
          <Card
            size="small"
            bordered={false}
            style={{
              height: "100%",
              borderRadius: 16,
              background: "#fff",
              border: "1px solid rgba(250,140,22,0.10)",
              boxShadow: "0 2px 12px rgba(250,140,22,0.06)",
              overflow: "hidden",
            }}
            bodyStyle={{ padding: 0 }}
          >
            {/* Section header */}
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "16px 20px",
              background: "linear-gradient(135deg, rgba(250,140,22,0.06), rgba(250,173,20,0.03))",
              borderBottom: "1px solid rgba(250,140,22,0.08)",
            }}>
              <div style={{
                width: 36, height: 36, borderRadius: 10,
                background: "linear-gradient(135deg, #fa8c16, #faad14)",
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0,
              }}>
                <HomeOutlined style={{ fontSize: 18, color: "#fff" }} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <Text strong style={{ fontSize: 14, display: "block" }}>مشخصات ساختمان</Text>
                <Text type="secondary" style={{ fontSize: 11 }}>کاربری، متراژ و اطلاعات واحد</Text>
              </div>
              <Tag color="orange" style={{
                borderRadius: 8, margin: 0, fontSize: 11, fontWeight: 600,
              }}>
                {{1: "مسکونی", 2: "تجاری", 3: "اداری", 4: "صنعتی", 5: "عمومی"}[+formInput.buildingTypeEnum || 1]}
              </Tag>
            </div>

            {/* Form body */}
            <div style={{ padding: "18px 20px" }}>
              <Row gutter={[12, 16]}>
                {/* Building type selector */}
                <Col xs={24}>
                  <Form.Item
                    label={<Text style={{ fontSize: 12, fontWeight: 500 }}>نوع کاربری</Text>}
                    style={{ margin: 0 }}
                  >
                    <Radio.Group
                      value={+formInput.buildingTypeEnum || 1}
                      onChange={e => {
                        handleSelectChange("buildingTypeEnum", e.target.value)
                        if (![1, 2].includes(e.target.value) && +formInput.unitNumber > 1) {
                          handleInput({ target: { name: "unitNumber", value: 1 } })
                        }
                      }}
                      style={{ width: "100%" }}
                    >
                      <Row gutter={[8, 8]}>
                        {[
                          { value: 1, label: "مسکونی", color: "#52c41a" },
                          { value: 2, label: "تجاری", color: "#1677ff" },
                          { value: 3, label: "اداری", color: "#722ed1" },
                          { value: 5, label: "عمومی", color: "#13c2c2" },
                          { value: 4, label: "صنعتی", color: "#fa541c" },
                        ].map(opt => {
                          const isActive = (+formInput.buildingTypeEnum || 1) === opt.value
                          return (
                            <Col key={opt.value} flex={1}>
                              <Radio.Button
                                value={opt.value}
                                style={{
                                  width: "100%",
                                  height: 36,
                                  lineHeight: "34px",
                                  textAlign: "center",
                                  borderRadius: 10,
                                  fontSize: 13,
                                  fontWeight: isActive ? 700 : 400,
                                  border: isActive ? `2px solid ${opt.color}` : "1.5px solid #e8e8e8",
                                  color: isActive ? opt.color : "#555",
                                  background: isActive ? `${opt.color}0a` : "transparent",
                                  boxShadow: isActive ? `0 0 0 1px ${opt.color}33` : "none",
                                }}
                              >
                                {opt.label}
                              </Radio.Button>
                            </Col>
                          )
                        })}
                      </Row>
                    </Radio.Group>
                  </Form.Item>
                </Col>

                {/* Piping type */}
                <Col xs={24}>
                  <Form.Item
                    label={<Text style={{ fontSize: 12, fontWeight: 500 }}>نوع لوله‌کشی</Text>}
                    style={{ margin: 0 }}
                  >
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: 10,
                    }}>
                      {[
                        { value: 0, label: "روکار", desc: "نصب بر سطح دیوار" },
                        { value: 1, label: "توکار", desc: "نصب داخل دیوار" },
                      ].map(opt => {
                        const isActive = +formInput.pipingTypeEnum === opt.value
                        return (
                          <div
                            key={opt.value}
                            onClick={() => handleInput({ target: { name: "pipingTypeEnum", value: opt.value } })}
                            style={{
                              padding: "12px 16px",
                              borderRadius: 12,
                              border: isActive ? "2px solid #1677ff" : "1.5px solid #f0f0f0",
                              background: isActive ? "#e6f4ff" : "#fafafa",
                              cursor: "pointer",
                              textAlign: "center",
                              transition: "all 0.25s ease",
                              boxShadow: isActive ? "0 2px 8px rgba(22,119,255,0.12)" : "none",
                            }}
                          >
                            <Text strong style={{
                              fontSize: 14,
                              color: isActive ? "#1677ff" : "#333",
                              display: "block",
                            }}>{opt.label}</Text>
                            <Text type="secondary" style={{ fontSize: 11 }}>{opt.desc}</Text>
                          </div>
                        )
                      })}
                    </div>
                  </Form.Item>
                </Col>

                {/* Has Burial */}
                <Col xs={24}>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "12px 16px",
                    borderRadius: 12,
                    border: formInput.hasBurial
                      ? "2px solid #722ed1"
                      : "1.5px solid #f0f0f0",
                    background: formInput.hasBurial
                      ? "linear-gradient(135deg, rgba(114,46,209,0.06), rgba(114,46,209,0.02))"
                      : "#fafafa",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                  }}
                    onClick={() => handleInput({ target: { name: "hasBurial", value: !formInput.hasBurial } })}
                  >
                    <Space size={10}>
                      <div style={{
                        width: 32, height: 32, borderRadius: 8,
                        background: formInput.hasBurial
                          ? "linear-gradient(135deg, #722ed1, #9254de)"
                          : "#e8e8e8",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        transition: "all 0.25s ease",
                      }}>
                        <span style={{ fontSize: 16, color: "#fff" }}>⚰</span>
                      </div>
                      <div>
                        <Text strong style={{
                          fontSize: 14,
                          color: formInput.hasBurial ? "#722ed1" : "#333",
                          display: "block",
                        }}>دفن لوله</Text>
                        <Text type="secondary" style={{ fontSize: 11 }}>آیا پروژه شامل عملیات دفن لوله است؟</Text>
                      </div>
                    </Space>
                    <Switch
                      checked={!!formInput.hasBurial}
                      onChange={checked => handleInput({ target: { name: "hasBurial", value: checked } })}
                      style={{
                        backgroundColor: formInput.hasBurial ? "#722ed1" : undefined,
                      }}
                    />
                  </div>
                </Col>

                {/* Numeric inputs */}
                <Col xs={12} sm={8}>
                  <Form.Item
                    label={<Text style={{ fontSize: 12, fontWeight: 500 }}>کد پستی</Text>}
                    style={{ margin: 0 }}
                    validateStatus={formInput.postalCode && formInput.postalCode.length !== 10 ? "error" : ""}
                    help={<Text type="secondary" style={{ fontSize: 10 }}>۱۰ رقم</Text>}
                  >
                    <Input
                      prefix={<NumberOutlined style={{ color: "#bbb", fontSize: 11 }} />}
                      required
                      name="postalCode"
                      type="number"
                      value={formInput.postalCode}
                      onChange={e => {
                        handleInput(e)
                        setIsErrorValid(e.target.value.length !== 10)
                      }}
                      style={{ borderRadius: 10, height: 42 }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={8}>
                  <Form.Item
                    label={<Text style={{ fontSize: 12, fontWeight: 500 }}>تعداد واحد</Text>}
                    style={{ margin: 0 }}
                    help={
                      ![1, 2].includes(+formInput.buildingTypeEnum || 1)
                        ? <Text type="warning" style={{ fontSize: 10, color: '#fa8c16' }}>فقط مسکونی و تجاری چند واحدی مجاز است</Text>
                        : null
                    }
                  >
                    <Input
                      required
                      name="unitNumber"
                      type="number"
                      min={1}
                      max={![1, 2].includes(+formInput.buildingTypeEnum || 1) ? 1 : undefined}
                      disabled={![1, 2].includes(+formInput.buildingTypeEnum || 1)}
                      value={![1, 2].includes(+formInput.buildingTypeEnum || 1) ? 1 : formInput.unitNumber}
                      onChange={e => {
                        handleInput(e)
                        setIsErrorValid(+e.target.value <= 0)
                      }}
                      style={{ borderRadius: 10, height: 42, textAlign: "center", fontWeight: 600 }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={8}>
                  <Form.Item
                    label={<Text style={{ fontSize: 12, fontWeight: 500 }}>طبقه</Text>}
                    style={{ margin: 0 }}
                    help={
                      <Text type="secondary" style={{ fontSize: 10 }}>
                        {+formInput.unitNumber > 1 ? "چند واحدی → همکف" : "0 = همکف"}
                      </Text>
                    }
                  >
                    <Input
                      required
                      name="floorNumber"
                      type="number"
                      disabled={+formInput.unitNumber > 1 || +formInput.unitNumber <= 0}
                      value={+formInput.unitNumber === 1 ? formInput.floorNumber : "0"}
                      onChange={handleInput}
                      style={{ borderRadius: 10, height: 42, textAlign: "center", fontWeight: 600 }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={12}>
                  <Form.Item
                    label={<Text style={{ fontSize: 12, fontWeight: 500 }}>شماره واحد</Text>}
                    style={{ margin: 0 }}
                  >
                    <Input
                      name="unitDes"
                      value={formInput.unitDes}
                      onChange={handleInput}
                      placeholder="مثلاً: ۱"
                      style={{ borderRadius: 10, height: 42, textAlign: "center" }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={<Text style={{ fontSize: 12, fontWeight: 500 }}>زیربنا (متر مربع)</Text>}
                    style={{ margin: 0 }}
                  >
                    <Input
                      required
                      name="area"
                      type="number"
                      min={1}
                      value={formInput.area}
                      suffix={<Text type="secondary" style={{ fontSize: 11 }}>م²</Text>}
                      onChange={e => {
                        handleInput(e)
                        setIsErrorValid(+e.target.value <= 0)
                      }}
                      style={{ borderRadius: 10, height: 42, textAlign: "center", fontWeight: 600 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Location card */}
      <Card
        bordered={false}
        style={{
          borderRadius: 16,
          background: "#fff",
          border: "1px solid rgba(82,196,26,0.10)",
          boxShadow: "0 2px 12px rgba(82,196,26,0.06)",
        }}
      >
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          marginBottom: 18,
          paddingBottom: 14,
          borderBottom: "1px solid #f6ffed",
        }}>
          <div style={{
            width: 36, height: 36, borderRadius: 10,
            background: "linear-gradient(135deg, #52c41a, #73d13d)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <EnvironmentOutlined style={{ fontSize: 18, color: "#fff" }} />
          </div>
          <div>
            <Text strong style={{ fontSize: 14, display: "block" }}>موقعیت مکانی</Text>
            <Text type="secondary" style={{ fontSize: 11 }}>آدرس و مختصات پروژه</Text>
          </div>
        </div>
        <Row gutter={[14, 16]}>
          <Col xs={24}>
            <Locations
              setDataAddress={setDataAddress}
              matches_sm={matches_sm}
              isAccessCity={false}
              idSection={userInfo && userInfo.idSection}
            />
          </Col>
          <Col xs={24}>
            <MapComp
              coords={dataAddress}
              setDataAddress={setDataAddress}
              mainAddress={formInput.fullAddress}
              matches_sm={matches_sm}
            />
          </Col>
          <Col xs={24}>
            <div style={{
              borderRadius: 10,
              background: "#f9fafb",
              padding: "10px 16px",
              display: "flex",
              alignItems: "center",
              gap: 16,
              flexWrap: "wrap",
            }}>
              <Space size={6}>
                <AimOutlined style={{ color: "#52c41a" }} />
                <Text type="secondary" style={{ fontSize: 12 }}>عرض:</Text>
                <Tag color="green" style={{ borderRadius: 6, fontVariantNumeric: "tabular-nums", margin: 0 }}>
                  {dataAddress.fullAddress.lat.toFixed(5)}
                </Tag>
              </Space>
              <Space size={6}>
                <AimOutlined style={{ color: "#1677ff" }} />
                <Text type="secondary" style={{ fontSize: 12 }}>طول:</Text>
                <Tag color="blue" style={{ borderRadius: 6, fontVariantNumeric: "tabular-nums", margin: 0 }}>
                  {dataAddress.fullAddress.lng.toFixed(5)}
                </Tag>
              </Space>
            </div>
          </Col>
        </Row>
      </Card>
    </Space>
  )
}
